import { render } from "./ViewEV.vue?vue&type=template&id=41a836e5"
import script from "./ViewEV.vue?vue&type=script&lang=js"
export * from "./ViewEV.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__